import NewInvoiceDialog from './NewInvoiceDialog.container';

export default NewInvoiceDialog;
